/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { ReactElement, useContext, useEffect, useState } from 'react'

import 'react-tooltip/dist/react-tooltip.css'

import {
  StopOutlined,
  MoreOutlined,
  WarningOutlined,
  CommentOutlined,
} from '@ant-design/icons'
import {
  Tag,
  Menu,
  Row,
  Col,
  Modal,
  Spin,
  Button,
  Dropdown,
  Typography,
  Card,
} from 'antd'
import MacrosIcon from 'Assets/macro.svg'
import ID_COMPONENTE from 'config/idComponente'
import TIPO_MACRO from 'config/tipoMacro'
import { ApplicationContext } from 'Context'
import buscaAgendamentoMultiplo from 'Helpers/agendamentoMultiplo'
import classificacaoHorarios from 'Helpers/classificacaoHorarios'
import Claims from 'Hooks/usePermissions/Claims'
import usePermissions from 'Hooks/usePermissions/usePermissions'
import { IPerfil, Roles } from 'Models/auth'
import moment from 'moment'
import { useSnackbar } from 'react-simple-snackbar'
import { Tooltip } from 'react-tooltip'
import WS_DOCAS from 'Services/WS_DOCAS'
import swal from 'sweetalert'
import { MsgSuccessOptions } from 'Types/SnackbarTypes'

import {
  IAgendaAction,
  IAlertaTipo,
  ICandidato,
  IHorario,
  IMacro,
} from '../../../Models/docas'
import { STATUS_HORARIOS } from '../../../Models/docas/IHorario'
import { DocasContext } from '../Context/context'
import ModalAlterarHorario from '../Modais/ModalAlterarHorario'
import ModalDetalhes from '../Modais/ModalDetalhes'

const { Paragraph } = Typography

interface IProps {
  horario: IHorario
  atualizaAgenda: (
    limparSelecao?: boolean,
    executandoAcao?: boolean,
  ) => Promise<void>
}

const CardAgendamento = ({ horario, atualizaAgenda }: IProps): ReactElement => {
  const { docasContext, setDocasContext } = useContext(DocasContext)
  const { isAuthorized } = usePermissions()
  const [selected, setSelected] = useState(false)
  const [activeTab, setActiveTab] = useState<number>(0)
  const [loading, setLoading] = useState(false)
  const [showModalAlterarHorario, setShowModalAlterarHorario] =
    useState<boolean>(false)
  const { applicationContext, setApplicationContext } =
    useContext(ApplicationContext)
  const [stoped, setStoped] = useState(false)
  const [openSnackbarSuccess, closeSnackbarSuccess] =
    useSnackbar(MsgSuccessOptions)
  const [idModal, setIdModal] = useState<number>(0)
  const [horarioSelecionado, setHorarioSelecionado] = useState<IHorario>()
  const [piscar, setPiscar] = useState<boolean>(false)
  const [avisar, setAvisar] = useState<boolean>(false)
  const [horarioPrincipal, setHorarioPrincipal] = useState<
    IHorario | undefined
  >()
  const [mostrarTooltip, setMostrarTooltip] = useState<boolean>(true)

  const alertaJustificado =
    horario.temAlerta && horario.alertas.every((s) => s.justificado)

  const MENU_ID = 'menu-id-' + horario.cdAgendamentoDocasHorario
  // const { show } = useContextMenu({
  //     id: MENU_ID
  // })

  const geraResumoMacros = (macros: IMacro[]): string => {
    if (macros.length > 0) {
      let resumo = `${macros[0].nome} - ${macros[0].data} - ${macros[0].usuarioNome}`

      for (let i = 1; i < macros.length; i++) {
        resumo += `<br />${macros[i].nome} - ${macros[i].data} - ${macros[i].usuarioNome}`
      }

      return resumo
    } else {
      return 'Sem macros'
    }
  }

  const atualizaDados = () => {
    const agendamentoMultiplo = buscaAgendamentoMultiplo(
      horario,
      docasContext.agendamentosMultiplos,
    )
    const principal = agendamentoMultiplo
      ? agendamentoMultiplo.horarios[0]
      : horario

    if (principal.cdMacro !== horarioPrincipal?.cdMacro) {
      setHorarioPrincipal(principal)
    }

    if (
      principal.cdMacroUsuarioExcetoOutros ===
      applicationContext.usuarioAtual?.cdUsuario
    ) {
      if (avisar) {
        setAvisar(false)

        if (piscar) {
          setPiscar(false)
        }
      }
    } else if (
      principal.temMacro &&
      docasContext.avisoPiscante &&
      !avisar &&
      docasContext.macrosParaAvisar.some(
        (f) => f.cdMacro === principal.cdMacroExcetoOutros,
      )
    ) {
      setAvisar(true)
    }

    if (horario.temAlerta) {
      const alertasSonoros = docasContext.alertasSonoros
      const i = alertasSonoros.findIndex(
        (f) => f.cdCandidato === horario.cdCandidatoAgendamento,
      )

      if (
        horario.alertas.some((s) => !s.justificado) &&
        (i === -1 || !docasContext.alertasSonoros[i].tocarSom)
      ) {
        let notificar = false

        for (let j = 0; !notificar && j < horario.alertas.length; j++) {
          const alerta: IAlertaTipo = docasContext.alertas.find(
            (f) => f.cdAlertaTipo === horario.alertas[j].cdAlertaTipo,
          )!

          if (alerta.idsRoles.length > 0 && applicationContext.usuarioAtual) {
            const roles: IPerfil[] = applicationContext.usuarioAtual.perfis
            for (let k = 0; k < roles.length; k++) {
              if (alerta.idsRoles.includes(roles[k].id)) {
                notificar = true
                break
              }
            }
          } else {
            notificar = true
          }
        }

        if (notificar) {
          if (i === -1) {
            alertasSonoros.push({
              cdCandidato: horario.cdCandidatoAgendamento!,
              tocarSom: true,
            })
          } else {
            alertasSonoros[i].tocarSom = true
          }
        }

        setDocasContext({ ...docasContext, alertasSonoros: alertasSonoros })
      }
    }
  }

  useEffect(() => {
    atualizaDados()
  }, [docasContext.horarios])

  useEffect(() => {
    if (docasContext.armazemAtual?.cdMacroTipo === TIPO_MACRO.AVANCADO) {
      if (avisar && docasContext.avisoPiscante) {
        setTimeout(() => setPiscar(!piscar), 200)
      } else if (piscar) {
        setPiscar(false)
      }
    }
  }, [piscar, avisar, docasContext.avisoPiscante])

  const toggleClick = () => {
    setStoped(true)
    setTimeout(() => setStoped(false), 1000)
  }

  const toggleSelect = () => {
    // if (moment(horario.dtHora) > moment()) {
    let removeu = false
    let selecaoContinua = false

    //verifica se deve remover do array de selecionados
    let selecionadosAux: IHorario[] = []

    docasContext.selecionados?.map((item: IHorario) => {
      if (
        item.cdAgendamentoDocasHorario === horario.cdAgendamentoDocasHorario
      ) {
        setSelected(false)
        removeu = true
      } else {
        selecionadosAux.push(item)
      }
    })

    //caso não tenha sido necessário remover, deve-se incluir.
    if (!removeu) {
      selecionadosAux?.push(horario)
      setSelected(true)
    }

    //Ordena por horario
    selecionadosAux = selecionadosAux.sort(
      (a, b) => parseInt(a.hora.split(':')[0]) - parseInt(b.hora.split(':')[0]),
    )

    //varificar se é seleção continua
    if (selecionadosAux.length > 1 && selecionadosAux.length <= 3) {
      if (
        selecionadosAux.every(
          (item) =>
            item.cdAgendamendoDocasDocas ===
              selecionadosAux[0].cdAgendamendoDocasDocas &&
            item.cdAgendamentoDocasJanela ===
              selecionadosAux[0].cdAgendamentoDocasJanela,
        )
      ) {
        let x = -1

        selecionadosAux.map((item) => {
          if (x === -1) {
            x = parseInt(item.hora.split(':')[0])
          } else {
            if (parseInt(item.hora.split(':')[0]) === x + 1) {
              selecaoContinua = true
            } else {
              //Não é continua por que existe um intervalo na seleção
              selecaoContinua = false
            }
          }
        })
      } else {
        //Não é continua por que os selecionados não pertencem a mesma doca e ou mesma janela
        selecaoContinua = false
      }
    } else {
      //Não é continua por que o numero de selecionados é menor ou maior que o permitido
      selecaoContinua = false
    }

    setDocasContext({
      ...docasContext,
      selecionados: selecionadosAux,
      selecaoContinua,
      btnBloquearSelecionados:
        selecionadosAux?.filter(
          (x) => x.horarioStatus !== STATUS_HORARIOS.LIVRE,
        ).length > 0
          ? false
          : true,
      btnAprovarSelecionados:
        selecionadosAux?.filter(
          (x) => x.horarioStatus !== STATUS_HORARIOS.RESERVADO,
        ).length > 0
          ? false
          : true,
    })
    // }
  }

  const statusText = (status: number) => {
    let word = ''
    switch (status) {
      case 0:
        word = 'liberar'
        break
      case 2:
        word = 'aprovar'
        break
      case 3:
        word = 'cancelar'
        break
      case 4:
        word = 'bloquear'
        break
    }
    return word
  }

  const acaoHorario = async (status: number, horario: IHorario) => {
    swal({
      title: 'Confirmar?',
      text:
        status !== 5
          ? `Tem certeza que deseja ${statusText(status)} o horário?`
          : 'Tem certeza que deseja marcar este horário como Não Compareceu?',
      icon: 'warning',
      buttons: ['NÃO', 'SIM'],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        let data = undefined

        if (
          status === STATUS_HORARIOS.CANCELADO ||
          status === STATUS_HORARIOS.APROVADO ||
          status === STATUS_HORARIOS.NO_SHOW
        ) {
          const agendamentoMultiplo = buscaAgendamentoMultiplo(
            horario,
            docasContext.agendamentosMultiplos,
          )

          if (agendamentoMultiplo) {
            const itens: IAgendaAction[] = []

            agendamentoMultiplo.horarios.map((item) => {
              itens.push({
                cdAgendamentoDocasHorario: item.cdAgendamentoDocasHorario,
                horarioStatus: status,
                cdCandidatoAgendamento: item.cdCandidatoAgendamento!,
                agendamentoMultiplo: false,
                placaVeiculo: item.placa,
                transportadora: item.nomeEntidade,
                cdEntidade: item.cdEntidade,
                cdVeiculo: item.cdVeiculo,
              })
            })

            if (
              !itens.some(
                (s) =>
                  s.cdAgendamentoDocasHorario ==
                  horario.cdAgendamentoDocasHorario,
              )
            ) {
              itens.push({
                cdAgendamentoDocasHorario: horario.cdAgendamentoDocasHorario,
                horarioStatus: STATUS_HORARIOS.RESERVADO,
                cdCandidatoAgendamento: horario.cdCandidatoAgendamento!,
                agendamentoMultiplo: false,
                placaVeiculo: horario.placa,
                transportadora: horario.nomeTransportadora,
                cdEntidade: horario.cdEntidade,
                cdVeiculo: horario.cdVeiculo,
              })
            }

            data = await WS_DOCAS.agenda.executaAcao(ID_COMPONENTE.DOCAS, itens)
          }
        }

        if (!data) {
          const arr: IAgendaAction[] = []

          docasContext.selecionados?.map((h) => {
            arr.push({
              cdAgendamentoDocasHorario: h.cdAgendamentoDocasHorario,
              horarioStatus: status,
              cdCandidatoAgendamento: horario.cdCandidatoAgendamento ?? 0,
              agendamentoMultiplo: false,
              placaVeiculo: h.placa,
              transportadora: h.nomeEntidade,
              cdEntidade: h.cdEntidade,
              cdVeiculo: h.cdVeiculo,
            })
          })

          if (
            !arr.some(
              (h) =>
                h.cdAgendamentoDocasHorario ===
                horario.cdAgendamentoDocasHorario,
            )
          ) {
            arr.push({
              cdAgendamentoDocasHorario: horario.cdAgendamentoDocasHorario,
              horarioStatus: status,
              cdCandidatoAgendamento: horario.cdCandidatoAgendamento ?? 0,
              agendamentoMultiplo: false,
              placaVeiculo: horario.placa,
              transportadora: horario.nomeEntidade,
              cdEntidade: horario.cdEntidade,
              cdVeiculo: horario.cdVeiculo,
            })
          }

          data = await WS_DOCAS.agenda.executaAcao(ID_COMPONENTE.DOCAS, arr)
        }

        if (data.status === 200) {
          setLoading(true)
          setTimeout(() => setLoading(false), 1000)

          atualizaAgenda(true, loading)
        } else {
          openSnackbarSuccess(data.message)
        }
      }
    })
  }

  const reservaHorario = async (
    candidatoSelecionado: ICandidato,
    horario: IHorario,
    status: number = STATUS_HORARIOS.RESERVADO,
  ) => {
    let horariosSelecionados: IHorario[] = docasContext.selecionados
      ? docasContext.selecionados
      : [horario]

    if (
      !horariosSelecionados.some(
        (s) =>
          s.cdAgendamentoDocasHorario === horario.cdAgendamentoDocasHorario,
      )
    ) {
      horariosSelecionados.push(horario)
    }

    horariosSelecionados = verificaQuantidadeHorarios(
      horariosSelecionados,
      candidatoSelecionado.quantidadeHorarios,
    )

    const tamanhoJanelaSecundariaMinutos: number =
      docasContext.armazemAtual?.tamanhoJanelaSecundaria ?? 60

    if (
      classificacaoHorarios.verificaHorariosConsecutivos(
        horariosSelecionados,
        tamanhoJanelaSecundariaMinutos,
      )
    ) {
      if (verificaHorariosOcupados(horariosSelecionados)) {
        const arr: IAgendaAction[] = []

        horariosSelecionados.map((h) => {
          arr.push({
            cdAgendamentoDocasHorario: h.cdAgendamentoDocasHorario,
            horarioStatus: status,
            cdCandidatoAgendamento: candidatoSelecionado.cdCandidatoAgendamento,
            agendamentoMultiplo: false,
            placaVeiculo: candidatoSelecionado.placa,
            transportadora: candidatoSelecionado.nomeTransportadora,
            cdEntidade: candidatoSelecionado.cdEntidade,
            cdVeiculo: candidatoSelecionado.cdVeiculo,
            cdViagem: candidatoSelecionado.cdViagem,
          })
        })

        const response = await WS_DOCAS.agenda.executaAcao(
          ID_COMPONENTE.DOCAS,
          arr,
        )

        if (response.status === 200) {
          //Verifica o codigo retornado pelo WsDocas
          if (response.data.statusCode === 501) {
            setLoading(true)
            setTimeout(() => setLoading(false), 1000)

            atualizaAgenda(true)
          } else {
            alert(response.data.message)
          }
        }
      } else {
        openSnackbarSuccess(
          'Não é possível fazer uma reserva em horários já ocupados',
        )
      }
    } else {
      openSnackbarSuccess(
        'Não é possível fazer uma reserva em docas diferentes ou em horários não consecutivos',
      )
    }
  }

  const verificaQuantidadeHorarios = (
    horarios: IHorario[],
    quantidadeHorarios?: number,
  ): IHorario[] => {
    const horariosOrdenados: IHorario[] = horarios.sort((a, b) =>
      a.cdAgendamentoDocasHorario > b.cdAgendamentoDocasHorario ? 1 : -1,
    )

    if (quantidadeHorarios && quantidadeHorarios !== horarios.length) {
      if (quantidadeHorarios > horarios.length) {
        for (let i = horarios.length; i < quantidadeHorarios; i++) {
          const ultimoHorario: IHorario =
            horariosOrdenados[horariosOrdenados.length - 1]
          const proximoHorario: IHorario | undefined =
            docasContext.horarios?.find(
              (horario) =>
                horario.cdAgendamendoDocasDocas ===
                  ultimoHorario.cdAgendamendoDocasDocas &&
                horario.cdAgendamentoDocasJanela ===
                  ultimoHorario.cdAgendamentoDocasJanela &&
                moment(horario.dtHora) > moment(ultimoHorario.dtHora),
            )

          if (proximoHorario) {
            horariosOrdenados.push(proximoHorario)
          } else {
            break
          }
        }
      } else {
        while (quantidadeHorarios < horariosOrdenados.length) {
          horariosOrdenados.pop()
        }
      }
    }

    return horariosOrdenados
  }

  const verificaHorariosOcupados = (horarios: IHorario[]) =>
    !horarios.some((s) => s.cdCandidatoAgendamento)

  const isSelected = () => {
    if (docasContext?.selecionados) {
      const item = docasContext?.selecionados?.filter(
        (x) =>
          x.cdAgendamentoDocasHorario === horario.cdAgendamentoDocasHorario,
      )
      if (item && item.length && !isPast()) {
        if (docasContext?.selecaoContinua) {
          return 'selected-continuos'
        } else {
          return 'selected'
        }
      } else {
        return ''
      }
    }
  }

  const isPast = () => {
    const dataHorario: moment.Moment = moment(horario.dtHora)
    const dataAtual: moment.Moment = moment()

    return (
      dataHorario.isBefore(dataAtual) &&
      (dataHorario.dayOfYear() !== dataAtual.dayOfYear() ||
        dataHorario.hour() < dataAtual.hour())
    )
  }

  const verificaSeAgendamentoPertenceOutraTransportadora = (
    horario: IHorario,
  ) => {
    return applicationContext.usuarioAtual?.cdsTransportadoras?.every(
      (cdTransportadora) => cdTransportadora !== horario.cdEntidade,
    )
  }

  const verificaSeDesabilitaOpcaoTransportadora = (horario?: IHorario) => {
    return (
      !horario ||
      (!isAuthorized(Claims.VerDetalhesTodasTransportadoras) &&
        verificaSeAgendamentoPertenceOutraTransportadora(horario))
    )
  }

  const showCardTransportadora = () => {
    return (
      ((isAuthorized(Claims.VerDetalhesTodasTransportadoras) ||
        !verificaSeAgendamentoPertenceOutraTransportadora(horario)) &&
        (horario.horarioStatus === STATUS_HORARIOS.APROVADO ||
          horario.horarioStatus === STATUS_HORARIOS.RESERVADO)) ||
      horario.horarioStatus === STATUS_HORARIOS.LIVRE ||
      horario.horarioStatus === STATUS_HORARIOS.BLOQUEADO ||
      horario.horarioStatus === STATUS_HORARIOS.NO_SHOW
    )
  }

  const isSelectable = () => {
    return !docasContext.executing
  }

  const abreModal = (id: number) => {
    const agendamentoMultiplo = buscaAgendamentoMultiplo(
      horario,
      docasContext.agendamentosMultiplos,
    )

    if (
      agendamentoMultiplo?.horarios &&
      agendamentoMultiplo.horarios.length > 1
    ) {
      setHorarioSelecionado(agendamentoMultiplo.horarios[0])
    } else {
      setHorarioSelecionado(horario)
    }

    setIdModal(id)
  }

  const preparaModal = () => {
    if (horarioSelecionado) {
      setActiveTab(idModal)
    } else {
      setTimeout(() => {
        preparaModal()
      }, 500)
    }
  }

  const visualizaAlertas = async () => {
    const alertasNaoJustificados = horario.alertas.filter((f) => !f.justificado)

    if (alertasNaoJustificados.length > 0) {
      const alertasSonoros = docasContext.alertasSonoros

      for (let i = 0; i < alertasNaoJustificados.length; i++) {
        const j = alertasSonoros.findIndex(
          (f) => f.cdCandidato === horario.cdCandidatoAgendamento,
        )

        alertasSonoros[j].tocarSom = false
      }

      setDocasContext({
        ...docasContext,
        alertasSonoros: alertasSonoros,
      })
    }

    setActiveTab(4)
  }

  const trataFechamentoModalDetalhes = () => {
    setActiveTab(0)
    setMostrarTooltip(false)
    window.setTimeout(() => setMostrarTooltip(true), 500)
  }

  useEffect(() => {
    if (idModal !== 0) {
      preparaModal()
    }
  }, [idModal])

  const ajustaTexto = (titulo: string, texto?: string) => {
    if (texto) {
      const tamanhoMaximo: number = 39 - titulo.length

      if (texto.length > tamanhoMaximo) {
        return `${texto.substring(0, tamanhoMaximo)}...`
      }
    }

    return texto
  }

  const menu = (
    <Menu id={MENU_ID}>
      {isAuthorized(Claims.ReservarHorario) &&
        horario.horarioStatus === STATUS_HORARIOS.LIVRE && (
          <Menu.Item
            onClick={() =>
              reservaHorario(docasContext.candidatoSelecionado!, horario)
            }
            disabled={!docasContext.candidatoSelecionado || isPast()}
          >
            Reservar
          </Menu.Item>
        )}

      {isAuthorized(Claims.AprovarHorario) &&
        horario.horarioStatus === STATUS_HORARIOS.RESERVADO && (
          <Menu.Item
            onClick={() => acaoHorario(STATUS_HORARIOS.APROVADO, horario)}
            disabled={isPast()}
          >
            Aprovar
          </Menu.Item>
        )}

      {isAuthorized(Claims.ReservarAprovarHorario) &&
        horario.horarioStatus === STATUS_HORARIOS.LIVRE && (
          <Menu.Item
            onClick={() =>
              reservaHorario(
                docasContext.candidatoSelecionado!,
                horario,
                STATUS_HORARIOS.RESERVADO_APROVADO,
              )
            }
            disabled={!docasContext.candidatoSelecionado || isPast()}
          >
            Reservar e Aprovar
          </Menu.Item>
        )}

      {isAuthorized(Claims.BloquearHorario) &&
        horario.horarioStatus === STATUS_HORARIOS.LIVRE && (
          <Menu.Item
            onClick={() => acaoHorario(STATUS_HORARIOS.BLOQUEADO, horario)}
            disabled={isPast()}
          >
            Bloquear
          </Menu.Item>
        )}

      {isAuthorized(Claims.CancelarHorario) &&
        (horario.horarioStatus === STATUS_HORARIOS.RESERVADO ||
          horario.horarioStatus === STATUS_HORARIOS.APROVADO) && (
          <Menu.Item
            onClick={() => acaoHorario(STATUS_HORARIOS.CANCELADO, horario)}
            disabled={verificaSeDesabilitaOpcaoTransportadora(horario)}
          >
            Cancelar
          </Menu.Item>
        )}

      {isAuthorized(Claims.LiberarHorario) &&
        horario.horarioStatus === STATUS_HORARIOS.BLOQUEADO && (
          <>
            <Menu.Item
              onClick={() => acaoHorario(STATUS_HORARIOS.LIVRE, horario)}
              disabled={isPast()}
            >
              Liberar
            </Menu.Item>
          </>
        )}

      {isAuthorized(Claims.NoShowHorario) &&
        horario.horarioStatus === STATUS_HORARIOS.APROVADO && (
          <Menu.Item
            onClick={() => acaoHorario(STATUS_HORARIOS.NO_SHOW, horario)}
            disabled={moment(horario.dtHora) > moment()}
          >
            Não compareceu
          </Menu.Item>
        )}

      {isAuthorized(Claims.AlterarHorario) &&
        (horario.horarioStatus === STATUS_HORARIOS.RESERVADO ||
          horario.horarioStatus === STATUS_HORARIOS.APROVADO) && (
          <Menu.Item
            onClick={() => setShowModalAlterarHorario(true)}
            disabled={isPast()}
          >
            Alterar
          </Menu.Item>
        )}

      {isAuthorized(Claims.VerDetalhes) &&
        (horario.horarioStatus === STATUS_HORARIOS.RESERVADO ||
          horario.horarioStatus === STATUS_HORARIOS.APROVADO) && (
          <Menu.Item
            disabled={
              !isSelectable() ||
              verificaSeDesabilitaOpcaoTransportadora(horario)
            }
            onClick={() => abreModal(1)}
          >
            Detalhes
          </Menu.Item>
        )}

      {isAuthorized(Claims.VerDetalhes) &&
        (horario.horarioStatus === STATUS_HORARIOS.RESERVADO ||
          horario.horarioStatus === STATUS_HORARIOS.APROVADO) && (
          <Menu.Item
            onClick={() => abreModal(2)}
            disabled={verificaSeDesabilitaOpcaoTransportadora(horario)}
          >
            Macros
          </Menu.Item>
        )}

      {isAuthorized(Claims.VerDetalhes) &&
        (horario.horarioStatus === STATUS_HORARIOS.RESERVADO ||
          horario.horarioStatus === STATUS_HORARIOS.APROVADO) && (
          <Menu.Item
            onClick={() => abreModal(4)}
            disabled={verificaSeDesabilitaOpcaoTransportadora(horario)}
          >
            Alertas
          </Menu.Item>
        )}

      {isAuthorized(Claims.Chat) && (
        <Menu.Item
          disabled={
            horario.horarioStatus === STATUS_HORARIOS.BLOQUEADO ||
            (horario.horarioStatus === STATUS_HORARIOS.LIVRE &&
              applicationContext.usuarioAtual?.cdEntidade !==
                horario.cdEntidade)
          }
          onClick={() => abreModal(3)}
        >
          Chat
        </Menu.Item>
      )}

      {/* {isAuthorized(Claims.Chat) && (
        <Menu.Item
          disabled={
            horario.horarioStatus === STATUS_HORARIOS.BLOQUEADO ||
            (horario.horarioStatus === STATUS_HORARIOS.LIVRE &&
              applicationContext.usuarioAtual?.cdEntidade !==
                horario.cdEntidade)
          }
          onClick={() => abreModal(3)}
        >
          Checklist
        </Menu.Item>
      )} */}
    </Menu>
  )

  return (
    <>
      {!piscar ? (
        <Card
          className={`card-agendamento ${isSelected()} card-status-${
            horario.horarioStatus
          } ${isPast() ? 'card-past' : ''} `}
        >
          <Dropdown
            overlay={menu}
            trigger={['contextMenu']}
            disabled={!isSelectable()}
          >
            <div
              onClick={() => (isSelectable() ? toggleSelect() : toggleClick())}
            >
              {stoped ? (
                <Row justify="center" align="middle" style={{ width: '100%' }}>
                  <StopOutlined />
                </Row>
              ) : (
                <>
                  {loading ? (
                    <Row
                      justify="center"
                      align="middle"
                      style={{
                        width: '100%',
                      }}
                    >
                      <Spin />
                    </Row>
                  ) : (
                    <>
                      <Row>
                        <Col flex="auto">
                          {showCardTransportadora() ? (
                            <div style={{ overflow: 'auto', height: '60px' }}>
                              <Paragraph
                                className="agendaLabels"
                                style={{
                                  visibility: horario.placa
                                    ? 'visible'
                                    : 'hidden',
                                }}
                              >
                                <b>Placa:</b> {horario.placa}
                              </Paragraph>
                              <div
                                style={{
                                  display: horario.documentoViagem
                                    ? 'block'
                                    : 'none',
                                }}
                              >
                                <Paragraph className="agendaLabels">
                                  <b>
                                    {applicationContext.textoDocumentoViagem!}:
                                  </b>{' '}
                                  {ajustaTexto(
                                    applicationContext.textoDocumentoViagem!,
                                    horario.documentoViagem,
                                  )}
                                </Paragraph>
                              </div>
                              <div
                                style={{
                                  visibility: horario.nomeEntidade
                                    ? 'visible'
                                    : 'hidden',
                                }}
                              >
                                <Paragraph className="agendaLabels">
                                  <b>Transportadora:</b>{' '}
                                  {ajustaTexto(
                                    'Transportadora',
                                    horario.nomeEntidade,
                                  )}
                                </Paragraph>
                              </div>
                              <div
                                style={{
                                  display: horario.origemViagem
                                    ? 'block'
                                    : 'none',
                                }}
                              >
                                <Paragraph className="agendaLabels">
                                  <b>Origem:</b>{' '}
                                  {ajustaTexto('Origem', horario.origemViagem)}
                                </Paragraph>

                                <Paragraph className="agendaLabels">
                                  <b>Destino:</b>{' '}
                                  {ajustaTexto(
                                    'Destino',
                                    horario.destinoViagem,
                                  )}
                                </Paragraph>
                              </div>
                              <div
                                style={{
                                  visibility: horario.nomeMotorista
                                    ? 'visible'
                                    : 'hidden',
                                }}
                              >
                                <Paragraph className="agendaLabels">
                                  <b>Motorista:</b>{' '}
                                  {ajustaTexto(
                                    'Motorista',
                                    horario.nomeMotorista,
                                  )}
                                </Paragraph>
                              </div>
                            </div>
                          ) : (
                            <>
                              <Paragraph className="agendaLabels">
                                <b>Placa:</b> ********
                              </Paragraph>
                              <Paragraph className="agendaLabels">
                                <b>
                                  {applicationContext.textoDocumentoViagem!}:
                                </b>{' '}
                                ********
                              </Paragraph>
                              <Paragraph className="agendaLabels">
                                <b>Transportadora:</b> ********
                              </Paragraph>
                              <Paragraph className="agendaLabels">
                                <b>Origem:</b> ********
                              </Paragraph>
                              <Paragraph className="agendaLabels">
                                <b>Destino:</b> ********
                              </Paragraph>
                              <Paragraph className="agendaLabels">
                                <b>Motorista:</b> ********
                              </Paragraph>
                            </>
                          )}
                        </Col>
                        <Col
                          flex="0"
                          style={{ marginTop: '-6px', marginLeft: '-55px' }}
                        >
                          <Dropdown
                            overlay={menu}
                            trigger={['click']}
                            disabled={!isSelectable()}
                          >
                            <Button
                              type="link"
                              aria-label="more"
                              aria-controls="long-menu"
                              aria-haspopup="true"
                            >
                              <MoreOutlined />
                            </Button>
                          </Dropdown>
                        </Col>
                      </Row>

                      <Row justify="space-between" align="top">
                        <Col>
                          <Tag color="#098fb8">
                            {horario.hora.substring(0, 5)}
                          </Tag>
                          {(horario.horarioStatus === STATUS_HORARIOS.LIVRE ||
                            horario.horarioStatus ===
                              STATUS_HORARIOS.CANCELADO) && (
                            <Tag color="#9b9b9b">Livre</Tag>
                          )}
                          {horario.horarioStatus ===
                            STATUS_HORARIOS.APROVADO && (
                            <Tag
                              color={
                                docasContext.armazemAtual?.cdMacroTipo !==
                                  TIPO_MACRO.AVANCADO || !horario.corMacro
                                  ? '#0bc769'
                                  : horario.corMacro
                              }
                            >
                              Aprovado
                            </Tag>
                          )}
                          {horario.horarioStatus ===
                            STATUS_HORARIOS.BLOQUEADO && (
                            <Tag color="#c00808">Bloqueado</Tag>
                          )}
                          {horario.horarioStatus ===
                            STATUS_HORARIOS.RESERVADO && (
                            <Tag
                              color={
                                docasContext.armazemAtual?.cdMacroTipo !==
                                  TIPO_MACRO.AVANCADO || !horario.corMacro
                                  ? '#aca905'
                                  : horario.corMacro
                              }
                              style={{
                                color: '#000',
                              }}
                            >
                              Reservado
                            </Tag>
                          )}
                          {horario.horarioStatus ===
                            STATUS_HORARIOS.NO_SHOW && (
                            <Tag color="#098fb8">Não compareceu</Tag>
                          )}
                          {horario.ultimasMacros.length > 0 && (
                            <>
                              <Tag
                                id={`ultimaMacro${horario.cdAgendamentoDocasHorario}`}
                                color="#098fb8"
                              >
                                {horario.ultimasMacros[0].nome}
                              </Tag>

                              {mostrarTooltip && (
                                <Tooltip
                                  anchorId={`ultimaMacro${horario.cdAgendamentoDocasHorario}`}
                                  html={`${horario.ultimasMacros[0].data} - ${horario.ultimasMacros[0].usuarioNome}`}
                                  place="bottom"
                                  style={{ zIndex: 1 }}
                                />
                              )}
                            </>
                          )}
                        </Col>

                        <Col>
                          {horario.temMacro && (
                            <>
                              <Button
                                id={`macros${horario.cdAgendamentoDocasHorario}`}
                                type="link"
                                disabled={!isSelectable()}
                                onClick={() => setActiveTab(2)}
                                icon={
                                  <img
                                    style={{
                                      width: '20px',
                                      marginTop:
                                        !horario.temComentario &&
                                        !horario.temAlerta
                                          ? '-5px'
                                          : '-11px',
                                    }}
                                    src={MacrosIcon}
                                  />
                                }
                              />

                              {mostrarTooltip && (
                                <Tooltip
                                  anchorId={`macros${horario.cdAgendamentoDocasHorario}`}
                                  html={geraResumoMacros(horario.ultimasMacros)}
                                  place="bottom"
                                  style={{ zIndex: 1 }}
                                />
                              )}
                            </>
                          )}

                          {horario.temAlerta && (
                            <Button
                              type="link"
                              disabled={!isSelectable()}
                              onClick={async () => await visualizaAlertas()}
                              icon={
                                <WarningOutlined
                                  style={{
                                    color: alertaJustificado ? 'black' : 'red',
                                    fontSize: '20px',
                                  }}
                                />
                                // <img
                                //   style={{
                                //     width: '20px',
                                //   }}
                                //   src={NotificationsIcon}
                                // />
                              }
                            />
                          )}

                          {horario.temComentario &&
                            horario.cdCandidatoAgendamento &&
                            !verificaSeDesabilitaOpcaoTransportadora(
                              horario,
                            ) && (
                              <Button
                                type="link"
                                disabled={!isSelectable()}
                                onClick={() => setActiveTab(3)}
                                icon={
                                  <CommentOutlined
                                    style={{
                                      color: 'black',
                                      fontSize: '20px',
                                    }}
                                  />
                                  // <img
                                  //   style={{
                                  //     width: '20px',
                                  //   }}
                                  //   src={ChatIcon}
                                  //   alt=""
                                  // />
                                }
                              />
                            )}
                        </Col>
                      </Row>
                    </>
                  )}{' '}
                </>
              )}
            </div>
          </Dropdown>
        </Card>
      ) : null}

      <Modal
        centered
        forceRender={true}
        visible={activeTab !== 0}
        onCancel={() => trataFechamentoModalDetalhes()}
        afterClose={() => setIdModal(0)}
        footer={[]}
        width={1000}
      >
        <div className="paper" style={{ height: '600px' }}>
          {activeTab && (
            <ModalDetalhes
              horario={horarioSelecionado ? horarioSelecionado : horario}
              startTab={activeTab}
              cdMacroTipo={docasContext.armazemAtual?.cdMacroTipo}
              setHorarioPrincipal={setHorarioPrincipal}
              atualizaAgenda={atualizaAgenda}
            />
          )}
        </div>
      </Modal>

      <Modal
        centered
        visible={showModalAlterarHorario}
        onCancel={() => setShowModalAlterarHorario(false)}
        afterClose={() => setIdModal(0)}
        footer={[]}
        width={500}
      >
        <div className="paper" style={{ height: '600px' }}>
          <ModalAlterarHorario
            horario={horario}
            atualizaAgenda={atualizaAgenda}
          />
        </div>
      </Modal>
    </>
  )
}

export default CardAgendamento
